// extracted by mini-css-extract-plugin
export default {"crossIcon":"ex8nfQb6eUva_WY2oF8w","addButton":"LDEMbhggMrp9EX3LB_Xv"};